import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {cityAPI} from 'features/admin/api/cityAPI';
import {getPollingInterval} from 'shared/api/pollingHelper';
import useListParams from 'shared/lib/hooks/useListParams';

import {CITY_FILTER_KEYS} from '../../lib/adminFilterKeys';
import AdminListScreen from '../AdminList/AdminListScreen/AdminListScreen';
import AdminCreateButton from '../AdminList/AdminCreateButton';
import CitiesRow from './CitiesRow';
import CitiesModal from './CitiesModal';
import CitiesFiltersForm from './CitiesFiltersForm/CitiesFiltersForm';

const Cities: React.FC = () => {
    const params = useListParams({filterKeys: CITY_FILTER_KEYS});
    const query = cityAPI.useGetCitiesQuery(params.args, {pollingInterval: getPollingInterval()});

    return (
        <AdminListScreen
            title={t`Города`}
            heading={i18n._(Pages.CITIES)}
            createButton={<AdminCreateButton label={t`Добавить город`} Modal={CitiesModal}/>}
            columns={[
                {label: 'ID', sort: 'id'},
                {label: 'Название', sort: 'name'},
                {label: 'Страна', sort: 'country.name'},
                {label: 'Зона', sort: 'country.zone.name'},
                {label: ''},
            ]}
            params={params}
            query={query}
            rowFactory={item => <CitiesRow key={item.id} item={item}/>}
            FiltersForm={CitiesFiltersForm}
        />
    );
};

export default React.memo(Cities);
